export default __webpack_public_path__ + "static/media/Atualizar Bancos de Dados.dd5dac78.svg";